module.exports = __webpack_public_path__ + "img/emblem_7.e77a57dc.svg";